<template>
  <div v-if="store.user">
    <form @submit.prevent="createSpace">
      <input
          v-model="spaceName"
          type="text"
          placeholder="Název účtu"
          class="rounded mr-2 w-full lg:w-2/5"
          required
      />
      <input
          v-model="projectName"
          type="text"
          placeholder="Název prvního projektu"
          required
          class="rounded mr-2 w-full lg:w-2/5"
      />
      <input
          class="my-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          type="submit"
          value="vytvořit"
      />
    </form>
  </div>

</template>

<script>
import {useNotificationStore} from "@/stores/notificationStore";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "createAccountForm",
  data() {
    return {
      spaceName: "",
      projectName: "",
      store: useAppStore(),
      notificationStore: useNotificationStore(),
    };
  },
  methods: {
    async createSpace() {

      console.log(this.$spacesApi);
      console.log(this.$projectsApi);
      console.log(this.$usersApi);

      if (
          this.spaceName.length > 0 &&
          this.projectName.length > 0
      ) {

        // vytvoření space
        const space =
            await this.$spacesApi.createSpace({
              name: this.spaceName,
              slug: this.store.toUrl(this.spaceName),
              usersIds: [this.store.mongoUser._id],
            }).then(response => {
              return response.data;
            }).catch(e => {
              console.log(e)
              this.notificationStore.error("Účet se nevytvořil: " + e.response.data.message);
            });

        if (space) {
          this.notificationStore.success("účet byl vytvořen")

          // přidání projektu
          const project =
              await this.$projectsApi.createProject(
                  space._id,
                  {name: this.projectName, slug: this.store.toUrl(this.projectName), spaceId: space._id},
              ).then(response => {
                return response.data;
              }).catch(e => console.log(e));
          if (project) {
            this.notificationStore.success("projekt byl vytvořen")
          } else {
            this.notificationStore.error("projekt se nevytvořil")
          }
        }
        this.spaceName = "";
        this.projectName = "";
        console.log(space);
        // přenačtení projektů a usera.
        this.store.projects = await this.$usersApi.getUsersProjects().then(response => response.data);
        this.store.mongoUser = await this.$usersApi.getMe().then(response => response.data)
      }
    },
  },
  async created() {
    this.notificationStore.notify = this.$notify;
  },
};
</script>

<style scoped></style>
